import React from 'react';
import './ViewDashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <div className="dashboardtitle">
      <h5>Welcome to DSH India Logistics Online Application</h5>
      </div>
      <div className="grid-container">
        <div className="grid-item">Shipment Created</div>
        <div className="grid-item blue">Shipment Pending</div>
        <div className="grid-item grey">Shipment Received</div>
        <div className="grid-item">Out for Delivery</div>
        <div className="grid-item orange">Unapproved Shipments</div>
        <div className="grid-item red">Delivery Completed</div>
        <div className="grid-item">Issue Raised</div>
        <div className="grid-item green">Issue Solved</div>
      </div>
      <div className="track-shipment">
        <h4>Track a Shipment</h4>
        <input type="text" placeholder="Enter Shipment Number" />
        <button>Search</button>
      </div>
    </div>
  );
};

export default Dashboard;
